import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {when} from 'lit/directives/when.js';
import {repeat} from 'lit/directives/repeat.js';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {msg} from '@lit/localize';
import store from '../../../store';
import {conditional} from '../../../util/conditional';
import {getProductData} from '../../../util/getProductData';
import {pimText, pimTextDebug} from '../../../util/values';
import {selectSpcConfiguration} from '../../../selectors';

@customElement('iomo-specsheet-drill-page')
export class IomoSpecsheetDrillPage extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				margin: 0;
			}

			.pageContainer {
				display: flex;
				justify-content: space-between;
				width: 100%;
				gap: 1cqw;
				padding-top: 2cqw;
			}

			.imageContainer {
				text-align: center;
				width: 80%;
				margin-left: 0;
				margin-right: auto;
			}

			img {
				max-width: 100%;
			}

			.productImage {
				max-width: 100%;
			}
			.head
		`]
	;

	@property({type: Object})
	headData = null;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.productData = state.productData;
		this.status = state.status;
		this.lang = state.status.lang;
		this.lightProfile = state.lightProfile.data;
		this.spcConfiguration = selectSpcConfiguration(state);
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
	}

	getValueFromProductData(featureId, featureValueId) {
		const pd = getProductData(featureId, this.productData);
		return pd?.values?.find(val => val.valueId === featureValueId);
	}

	t(featureId, context, value, prefix, suffix) {
		return this.debug ?
			pimTextDebug(this.lang, featureId, context, this.spcConfiguration, this.state.productData.translations, value, prefix, suffix) :
			pimText(this.lang, featureId, context, this.spcConfiguration, this.state.productData.translations, value, prefix, suffix);
	}

	c(id) {
		return conditional(this.spcConfiguration, this.conditionalVariantValues, id);
	}

	render() {
		const s = this.state;
		return html`
			<div class="pageContainer">
				<iomo-specsheet-drill-table></iomo-specsheet-drill-table>
			</div>
        `;
	}
}
